module.exports = __webpack_public_path__ + "img/basic-unit-icon-active.75350e8a.svg";